import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Product } from 'src/app/openapi/api';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-products-detail-section-b',
  templateUrl: './products-detail-section-b.component.html',
  styleUrls: ['./products-detail-section-b.component.scss']
})
export class ProductsDetailSectionBComponent extends BaseComponent implements OnInit {
  @Input()
  product: Product;
  
  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
  }

}
